"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var attending_service_1 = require("../../../service/attending.service");
var installation_period_1 = require("../../../constants/installation-period");
var attending_status_1 = require("../../../constants/attending-status");
var toast_service_1 = require("../../../../shared/service/toast.service");
var monitoring_step_status_1 = require("../../../constants/monitoring-step-status");
var equipment_service_1 = require("../../../../shared/service/equipment.service");
var sim_card_service_1 = require("../../../../shared/service/sim-card.service");
var attending_type_1 = require("../../../constants/attending-type");
var MonitoringPreEvaluationComponent = /** @class */ (function () {
    function MonitoringPreEvaluationComponent(_attendingService, _toastService, _equipmentService, _simCardService) {
        this._attendingService = _attendingService;
        this._toastService = _toastService;
        this._equipmentService = _equipmentService;
        this._simCardService = _simCardService;
        this.equipments = new Array();
        this.simCards = new Array();
        this.equipmentAttributesTree = ['serial'];
        this.simCardAttributesTree = ['iccid'];
        this.EQUIPMENT_STATUS_NAME_IN_ATTENDING = 'EM_ATENDIMENTO';
        this.setUpObservers();
    }
    MonitoringPreEvaluationComponent.prototype.ngOnInit = function () {
        this.setupEmptyEntities();
    };
    Object.defineProperty(MonitoringPreEvaluationComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
            this.handle();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MonitoringPreEvaluationComponent.prototype, "viewMode", {
        get: function () {
            return this._viewMode;
        },
        set: function (viewMode) {
            this._viewMode = viewMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MonitoringPreEvaluationComponent.prototype, "modelFiles", {
        get: function () {
            return this._modelFiles;
        },
        set: function (modelFiles) {
            this._modelFiles = modelFiles;
        },
        enumerable: true,
        configurable: true
    });
    MonitoringPreEvaluationComponent.prototype.markAsAccepted = function (file) {
        var _this = this;
        file.accepted = file.accepted ? !file.accepted : true;
        this._attendingService.acceptInfoFile(file.id, file.accepted, this._attending.id).subscribe(function (response) { return file = response; }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringPreEvaluationComponent.prototype.handleRejection = function (file) {
        file.accepted = false;
        this.removeFileFromMemoryList(file);
        this.deleteInfoFile(file);
        this.createUnsentParts(this.files);
    };
    MonitoringPreEvaluationComponent.prototype.canContinue = function () {
        if (this.vehicleParts) {
            var filesToBeAccepted = this.getFilesToBeAcceptedSize();
            var filesAccepted = this.getAcceptedFilesSize();
            return filesAccepted >= filesToBeAccepted;
        }
        return false;
    };
    MonitoringPreEvaluationComponent.prototype.submit = function () {
        var _this = this;
        var allFilesReachedBackEnd = this._attendingService.getCanContinueMonitoringWorkFlow(this.attending.id, installation_period_1.InstallationPeriod.PRE_INSTALLATION);
        if (allFilesReachedBackEnd) {
            this._attendingService.updateStatus(this._attending.id, attending_status_1.AttendingStatus.STARTED).subscribe(function (response) {
                _this.showMessage('Monitoramento atualizado!');
                _this._attending.monitoring.preEvaluationStep = monitoring_step_status_1.MonitoringStepStatus.FINISHED;
                _this._attending.monitoring.validationStep = monitoring_step_status_1.MonitoringStepStatus.CURRENT;
            }, function (error) { return _this.showMessage(error.text); });
        }
        else {
            this.showMessage("Ocorreu um erro durante a confirmação de um dos arquivos, por favor atualize a página!");
        }
    };
    MonitoringPreEvaluationComponent.prototype.handle = function () {
        var _this = this;
        this._attendingService
            .getVehicleParts(this._attending.id, installation_period_1.InstallationPeriod.PRE_INSTALLATION)
            .subscribe(function (response) {
            _this.vehicleParts = response;
            _this.handleFiles();
        }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringPreEvaluationComponent.prototype.handleFiles = function () {
        this.files = new Array();
        if (this.attending.attendingInfo.files && this.attending.attendingInfo.files.length > 0) {
            this.handleExistingFiles();
        }
        else {
            this.simpleCreateEmptyFiles(this.vehicleParts);
        }
    };
    MonitoringPreEvaluationComponent.prototype.handleExistingFiles = function () {
        this.setFiles();
        this.createUnsentParts(this._attending.attendingInfo.files);
    };
    MonitoringPreEvaluationComponent.prototype.createUnsentParts = function (files) {
        var unsentParts = this.getUnsentVehicleParts(files);
        if (unsentParts.length > 0) {
            this.createEmptyFiles(this.vehicleParts, unsentParts);
        }
    };
    MonitoringPreEvaluationComponent.prototype.getUnsentVehicleParts = function (files) {
        var partsToCreate = new Array();
        var _loop_1 = function (key) {
            var mustCreate = true;
            files.forEach(function (value) {
                if (value.vehiclePart === key) {
                    mustCreate = false;
                }
            });
            if (mustCreate) {
                partsToCreate.push(key);
            }
        };
        for (var key in this.vehicleParts) {
            _loop_1(key);
        }
        return partsToCreate;
    };
    MonitoringPreEvaluationComponent.prototype.setFiles = function () {
        var _this = this;
        this.attending.attendingInfo.files.forEach(function (value) {
            if (value.period === installation_period_1.InstallationPeriod.PRE_INSTALLATION) {
                _this.files.push(value);
            }
        });
    };
    MonitoringPreEvaluationComponent.prototype.createEmptyFiles = function (vehicleParts, keysToCreate) {
        for (var key in vehicleParts) {
            if (keysToCreate.includes(key)) {
                this.files.push({
                    description: vehicleParts[key],
                    vehiclePart: key,
                    accepted: false,
                    period: installation_period_1.InstallationPeriod.PRE_INSTALLATION
                });
            }
        }
    };
    MonitoringPreEvaluationComponent.prototype.simpleCreateEmptyFiles = function (vehicleParts) {
        for (var key in vehicleParts) {
            this.files.push({
                description: vehicleParts[key],
                vehiclePart: key,
                accepted: false,
                period: installation_period_1.InstallationPeriod.PRE_INSTALLATION
            });
        }
    };
    MonitoringPreEvaluationComponent.prototype.getAcceptedFilesSize = function () {
        var size = 0;
        this.files.forEach(function (value) {
            if (value.accepted) {
                size = size + 1;
            }
        });
        return size;
    };
    MonitoringPreEvaluationComponent.prototype.getFilesToBeAcceptedSize = function () {
        var size = 0;
        for (var key in this.vehicleParts) {
            size = 1 + size;
        }
        return size;
    };
    MonitoringPreEvaluationComponent.prototype.removeFileFromMemoryList = function (file) {
        var fileIndex = this.files.indexOf(file);
        this.files.splice(fileIndex, 1);
    };
    MonitoringPreEvaluationComponent.prototype.deleteInfoFile = function (file) {
        var _this = this;
        this._attendingService.deleteInfoFile(file.id, this._attending.id).subscribe(function (response) {
            _this.showMessage('Arquivo removido com sucesso!');
        }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringPreEvaluationComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 40000);
    };
    MonitoringPreEvaluationComponent.prototype.updateEquipment = function () {
        var _this = this;
        var updateEquipmentInfo = {
            'equipmentStatusName': this.EQUIPMENT_STATUS_NAME_IN_ATTENDING,
            'equipment': this.equipmentSelected,
            'simCard': this.simCardSelected
        };
        this._attendingService.updateEquipmentInfo(this._attending.id, updateEquipmentInfo).subscribe(function (response) {
            return _this.showMessage('Equipamento atualizado com sucesso!');
        }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringPreEvaluationComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._equipmentService.find$
            .subscribe(function (equipments) { return _this.equipments = equipments; });
        this._simCardService.find$
            .subscribe(function (simCards) { return _this.simCards = simCards; });
    };
    MonitoringPreEvaluationComponent.prototype.findBySerial = function (serial) {
        this.typedSerial = serial;
        this._equipmentService.findBySerial(serial);
    };
    MonitoringPreEvaluationComponent.prototype.setupEmptyEntities = function () {
        this.changeEquipmentInfo = false;
        this.typedSerial = this.getCurrentEquipmentSerial();
        this.typedIccId = this.getCurrentSimCardIccId();
    };
    MonitoringPreEvaluationComponent.prototype.setChangeEquipmentInfo = function () {
        this.changeEquipmentInfo = !this.changeEquipmentInfo;
    };
    MonitoringPreEvaluationComponent.prototype.findByIccid = function (iccid) {
        this.typedIccId = iccid;
        this._simCardService.findAvailableSimCardsWithAccessByIccidContains(iccid);
    };
    MonitoringPreEvaluationComponent.prototype.canUpdate = function () {
        var validateSerial = this.equipmentSelected != null && this.typedSerial == this.equipmentSelected.serial;
        var validateSimCard = this.simCardSelected != null && this.typedIccId == this.simCardSelected.iccid;
        return validateSerial && validateSimCard;
    };
    MonitoringPreEvaluationComponent.prototype.getCurrentEquipment = function () {
        return this._attending.attendingEquipmentInfo.equipmentChosenForAttending;
    };
    MonitoringPreEvaluationComponent.prototype.getCurrentEquipmentSerial = function () {
        if (this.getCurrentEquipment() != null) {
            return this.getCurrentEquipment().serial;
        }
        else {
            return '';
        }
    };
    MonitoringPreEvaluationComponent.prototype.getCurrentSimCard = function () {
        if (this._attending.attendingEquipmentInfo.equipmentChosenForAttending &&
            this._attending.attendingEquipmentInfo.equipmentChosenForAttending.simCard != null) {
            return this._attending.attendingEquipmentInfo.equipmentChosenForAttending.simCard;
        }
        else {
            return null;
        }
    };
    MonitoringPreEvaluationComponent.prototype.getCurrentSimCardIccId = function () {
        if (this.getCurrentSimCard() != null) {
            return this.getCurrentSimCard().iccid;
        }
        else {
            return '';
        }
    };
    MonitoringPreEvaluationComponent.prototype.setEquipmentSelected = function (equipment) {
        this.equipmentSelected = equipment;
        if (this.equipmentSelected.simCard != null) {
            this.typedIccId = this.equipmentSelected.simCard.iccid;
            this.simCardSelected = this.equipmentSelected.simCard;
        }
        else {
            this.simCardSelected = this.getCurrentSimCard();
        }
    };
    MonitoringPreEvaluationComponent.prototype.setSimCardSelected = function (simCard) {
        this.simCardSelected = simCard;
        if (this.equipmentSelected == null) {
            this.equipmentSelected = this.getCurrentEquipment();
        }
    };
    MonitoringPreEvaluationComponent.prototype.attendingTypeIsAudit = function () {
        return this.attending.type == attending_type_1.AttendingType.AUDIT;
    };
    MonitoringPreEvaluationComponent.ctorParameters = function () { return [{ type: attending_service_1.AttendingService }, { type: toast_service_1.ToastService }, { type: equipment_service_1.EquipmentService }, { type: sim_card_service_1.SimCardService }]; };
    return MonitoringPreEvaluationComponent;
}());
exports.MonitoringPreEvaluationComponent = MonitoringPreEvaluationComponent;
//# sourceMappingURL=monitoring-pre-evaluation.component.js.map


// WEBPACK FOOTER //
// monitoring-pre-evaluation.component.js